const TOGGLE_DICCIONARY = 'TOGGLE_DICCIONARY'
const SET_PARAMS_DICCIONARY = 'SET_PARAMS_DICCIONARY'

export {TOGGLE_DICCIONARY, SET_PARAMS_DICCIONARY}
